import {
  GENERATE_PRICING_DRAFT,
  APPLY_PRICING,
  APPLY_PRICING_START,
  RESET_PRICING,
  RESET_PRICING_ORIGINAL_STATE,
  GENERATE_PRICING_DRAFT_LOADING,
  // GENERATE_FIRST_VISIT_PRICING_PACKAGE,
  API_PRICING_GENERATE,
  API_PRICING_GET_BREAKDOWN,
} from "../Constants";
import Api from "../Api";
import { APP_COUNTRY } from "../DataConstants";

export const generatePricing = (
  visitDrafts: any,
  visit_draft_ids: any,
  careRecipientId: string,
  requestDateTime: Date | undefined
) => {
  return (dispatch: any) => {
    dispatch({ type: GENERATE_PRICING_DRAFT_LOADING });
    Api.POST(
      API_PRICING_GENERATE,
      {
        visitDrafts,
        country: APP_COUNTRY,
        careRecipientId,
        requestDateTime,
      },
      (response) => {
        if (response && response.data.success) {
          dispatch({
            type: GENERATE_PRICING_DRAFT,
            pricingPackages: response.data.pricing_packages,
            selectedDraftIds: visit_draft_ids,
          });
        }
      },
      false
    );
  };
};

export const resetPricing = () => {
  return (dispatch: any) => {
    dispatch({ type: RESET_PRICING });
  };
};

export const resetPricingAll = () => {
  return (dispatch: any) => {
    dispatch({ type: RESET_PRICING_ORIGINAL_STATE });
  };
};

export const applyPricing = (
  visitDrafts: any[],
  pricingItems: any,
  transportSurcharge: any,
  urgentSurcharge: any,
  waiveTransport: boolean,
  waiveTransportReason: string,
  otherTransportWaiveReason: string,
  waiveUrgent: boolean,
  waiveUrgentReason: string,
  otherUrgentWaiveReason: string,
  paymentInstructions: string
) => {
  return (dispatch: any) => {
    dispatch({
      type: APPLY_PRICING_START,
    });

    Api.POST(
      API_PRICING_GET_BREAKDOWN,
      {
        visitDrafts,
        pricingItems,
        transportSurcharge,
        urgentSurcharge,
        waiveTransport,
        waiveUrgent,
      },
      (response) => {
        response &&
          dispatch({
            type: APPLY_PRICING,
            visitDrafts,
            pricingItems,
            transportSurcharge,
            urgentSurcharge,
            waiveTransport,
            waiveTransportReason,
            otherTransportWaiveReason,
            waiveUrgent,
            waiveUrgentReason,
            otherUrgentWaiveReason,
            paymentInstructions,
            visitFeeBreakdown: response.data.breakdown,
          });
      },
      false
    );
  };
};
